<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSelectionsStore } from '@/stores/useSelectionsStore'

const selectionsStore = useSelectionsStore()
const { currentStatusPartnerSelections } = storeToRefs(selectionsStore)

defineEmits(['update:filterValue'])
</script>

<template>
  <div class="filter-controls">
    <label for="filterInput">Filtre client : </label>
    <select
      id="filterInput"
      @change="$emit('update:filterValue', $event.target)"
      class="select max-w-xs select-bordered select-sm"
    >
      <option value=""></option>
      <option
        v-for="currentStatus in currentStatusPartnerSelections"
        :value="currentStatus.value"
        v-bind:key="currentStatus.value"
      >
        {{ currentStatus.name }}
      </option>
    </select>
  </div>
</template>
<style scoped></style>
